export const notificationMessage = {
  header: 'Upcoming Maintenance Alert',
  message: '',
};

export const wapGroups = [
  { key: '', value: '', text: '' },
  { key: 'WAP', value: 'WAP', text: 'WAP' },
  { key: 'WAP-ADMIN', value: 'WAP-ADMIN', text: 'WAP-ADMIN' },
  { key: 'WAP-USERADMIN', value: 'WAP-USERADMIN', text: 'WAP-USERADMIN' },
  { key: 'WAP-FULL', value: 'WAP-FULL', text: 'WAP-FULL' },
  { key: 'WAP-FULL-NOAUTORENEW', value: 'WAP-FULL-NOAUTORENEW', text: 'WAP-FULL-NOAUTORENEW' },
  { key: 'WAP-UPDATE', value: 'WAP-UPDATE', text: 'WAP-UPDATE' },
  { key: 'WAP-VERIFY', value: 'WAP-VERIFY', text: 'WAP-VERIFY' },
];

export const wapUserStatus = [
  { key: '', value: '', text: '' },
  { key: 'STAGED', value: 'STAGED', text: 'STAGED' },
  { key: 'PROVISIONED', value: 'PROVISIONED', text: 'PROVISIONED' },
  { key: 'ACTIVE', value: 'ACTIVE', text: 'ACTIVE' },
  { key: 'RECOVERY', value: 'RECOVERY', text: 'RECOVERY' },
  { key: 'PASSWORD_EXPIRED', value: 'PASSWORD_EXPIRED', text: 'PASSWORD EXPIRED' },
  { key: 'LOCKED_OUT', value: 'LOCKED_OUT', text: 'LOCKED OUT' },
  { key: 'SUSPENDED', value: 'SUSPENDED', text: 'SUSPENDED' },
  { key: 'DEPROVISIONED', value: 'DEPROVISIONED', text: 'DEPROVISIONED' },
];

export const wapClients = [
  { vendor: '', description: '' },
  {
    vendor: 'ARP',
    description: 'AARP Internal',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-800-516-1993',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: true,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'AON,BIG,EHA,EIL,EIP,ENT,ETE,GHI,GOH,HEI,HEM,HIS,HPO,HPT,IMI,INS,MER,MRS,PHD,SEQ,SMI,SVG,TWA,UBT,UET,UIG,WIS',
    description: 'UHC Master',
  },
  {
    vendor: 'BAR',
    description: 'Barclays',
    manualName: 'WAP_User_Manual.pdf',
    allowMultipleAccountsSearch: false,
    allowCCPayments: true,
    allowECheckPayments: false,
    hideNRTAForEnroll: false,
    hideBillMeLaterForEnroll: false,
    hideContributionOptionForRenew: false,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'BLP',
    description: 'Blue Print',
    manualName: 'WAP_User_Manual.pdf',
    allowMultipleAccountsSearch: false,
    allowCCPayments: true,
    allowECheckPayments: false,
    hideNRTAForEnroll: false,
    hideBillMeLaterForEnroll: false,
    hideContributionOptionForRenew: false,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'CRT',
    description: 'Cartus',
    manualName: 'WAP_User_Manual.pdf',
    allowMultipleAccountsSearch: false,
    allowCCPayments: true,
    allowECheckPayments: false,
    hideNRTAForEnroll: false,
    hideBillMeLaterForEnroll: false,
    hideContributionOptionForRenew: false,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'DDL',
    description: 'Delta Dental',
    manualName: 'WAP_User_Manual.pdf',
    allowMultipleAccountsSearch: false,
    allowCCPayments: true,
    allowECheckPayments: false,
    hideNRTAForEnroll: false,
    hideBillMeLaterForEnroll: false,
    hideContributionOptionForRenew: false,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'FOR',
    description: 'Farmers Insurance',
    manualName: 'WAP_User_Manual.pdf',
    allowMultipleAccountsSearch: false,
    allowCCPayments: true,
    allowECheckPayments: false,
    hideNRTAForEnroll: false,
    hideBillMeLaterForEnroll: false,
    hideContributionOptionForRenew: false,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'GRD',
    description: 'Guardian',
    manualName: 'WAP_User_Manual.pdf',
    allowMultipleAccountsSearch: false,
    allowCCPayments: true,
    allowECheckPayments: false,
    hideNRTAForEnroll: false,
    hideBillMeLaterForEnroll: false,
    hideContributionOptionForRenew: false,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'HUA',
    description: 'Hear USA',
    manualName: 'WAP_User_Manual.pdf',
    allowMultipleAccountsSearch: false,
    allowCCPayments: true,
    allowECheckPayments: false,
    hideNRTAForEnroll: false,
    hideBillMeLaterForEnroll: false,
    hideContributionOptionForRenew: false,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'NYL',
    description: 'NewYorkLife',
    manualName: 'WAP_User_Manual.pdf',
    allowMultipleAccountsSearch: false,
    allowCCPayments: true,
    allowECheckPayments: false,
    hideNRTAForEnroll: false,
    hideBillMeLaterForEnroll: false,
    hideContributionOptionForRenew: false,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'PHP',
    description: 'Philips',
    manualName: 'WAP_User_Manual.pdf',
    allowMultipleAccountsSearch: false,
    allowCCPayments: true,
    allowECheckPayments: false,
    hideNRTAForEnroll: false,
    hideBillMeLaterForEnroll: false,
    hideContributionOptionForRenew: false,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'RLG',
    description: 'Reallegacy',
    manualName: 'WAP_User_Manual.pdf',
    allowMultipleAccountsSearch: false,
    allowCCPayments: true,
    allowECheckPayments: false,
    hideNRTAForEnroll: false,
    hideBillMeLaterForEnroll: false,
    hideContributionOptionForRenew: false,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'WYT',
    description: 'WayForth',
    manualName: 'WAP_User_Manual.pdf',
    allowMultipleAccountsSearch: false,
    allowCCPayments: true,
    allowECheckPayments: false,
    hideNRTAForEnroll: false,
    hideBillMeLaterForEnroll: false,
    hideContributionOptionForRenew: false,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'EPH',
    description: 'EpicHearing',
    manualName: 'WAP_User_Manual.pdf',
    allowMultipleAccountsSearch: false,
    allowCCPayments: true,
    allowECheckPayments: false,
    hideNRTAForEnroll: false,
    hideBillMeLaterForEnroll: false,
    hideContributionOptionForRenew: false,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'AON',
    description: 'UHC Aon',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: true,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'BIG',
    description: 'UHC Berwick Insurance Group',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: true,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'EHA',
    description: 'UHC eHealth',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: true,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'EIL',
    description: 'UHC Ensurem II, LLC',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: true,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'EIP',
    description: 'UHC Elite Insurance Partners, LLC',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: false,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'ENT',
    description: 'UHC Entrecor',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: true,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'ETE',
    description: 'UHC eTeleQuote',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: true,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'GHI',
    description: 'UHC Get Health Insurance',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: true,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'GOH',
    description: 'UHC GoHealth',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: true,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'HEI',
    description: 'UHC Healthcompare Insurance',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: true,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'HEM',
    description: 'UHC Health Markets',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: true,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'HIS',
    description: 'UHC Heath IQ insurance Services, Inc.',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: false,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'HPO',
    description: 'UHC Health Plan One',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: false,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'HPT',
    description: 'UHC HealthPilot Technologies LLC',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: true,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'IMI',
    description: 'UHC InsureMe, Inc',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: true,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'INS',
    description: 'UHC Insuractive',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: true,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'MER',
    description: 'UHC Mercer',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: true,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'MRS',
    description: 'UHC M & R Solutions',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: true,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'PHD',
    description: 'UHC Producer Help Desk',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: false,
    allowECheckPayments: false,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'SEQ',
    description: 'UHC Select Quote',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: true,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'SMI',
    description: 'UHC Smart Match Insurance Solutions',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: false,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'SVG',
    description: 'UHC Spring Venture Group',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: false,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'TWA',
    description: 'UHC Tower Watson',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: true,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'UIG',
    description: 'UHC United Insurance Group Agency, Inc.',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: true,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'WIS',
    description: 'UHC Walmart Insurance Services, LLC',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-866-331-1964',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: false,
    allowECheckPayments: true,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'UBT',
    description: 'UHC Billing Team',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-800-516-1993',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: false,
    allowECheckPayments: false,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'UET',
    description: 'UHC Enrollment Team',
    altAccountNumberLogic: 'LOGIC-1',
    customerSupportNumber: '1-800-516-1993',
    manualName: 'WAP_User_Manual_UHC.pdf',
    allowMultipleAccountsSearch: true,
    allowCCPayments: false,
    allowECheckPayments: false,
    hideNRTAForEnroll: true,
    hideBillMeLaterForEnroll: true,
    hideContributionOptionForRenew: true,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'HGC',
    description: 'Hurtigruten',
    manualName: 'WAP_User_Manual.pdf',
    allowMultipleAccountsSearch: false,
    allowCCPayments: true,
    allowECheckPayments: true,
    hideNRTAForEnroll: false,
    hideBillMeLaterForEnroll: false,
    hideContributionOptionForRenew: false,
    pciCompliantForPayments: true,
  },
  {
    vendor: 'GET',
    description: 'Grand European Travel',
    manualName: 'WAP_User_Manual.pdf',
    allowMultipleAccountsSearch: false,
    allowCCPayments: true,
    allowECheckPayments: false,
    hideNRTAForEnroll: false,
    hideBillMeLaterForEnroll: false,
    hideContributionOptionForRenew: false,
    pciCompliantForPayments: true,
  },
];

export default wapClients;



// WEBPACK FOOTER //
// ./src/app/containers/Utils/wapData.js